<div class="dashboard-container">
  <div class="project-main-container">
    @if (projectList && projectList.length > 0) {
    <div class="project-view-container">
      <div class="dashboard-item project-allocation">
        <app-project-allocation [projectAllocationChartData]="projectAllocationChartData"></app-project-allocation>
      </div>
      <div class="dashboard-item section-with-text">
        <span class="completion-number count-number">{{ projectMetrics.averageCompletionDays }}</span>
        <div class="header-text">Days to Complete a Project</div>
      </div>
      <div class="dashboard-item project-status">
        <app-project-status [projectStatusData]="projectStatusData" [colorTheme]="colorTheme"></app-project-status>
      </div>
      <div class="dashboard-item new-project section-with-text">
        <span class="completion-number count-number">{{ projectMetrics.newProjectMonthCount }}</span>
        <div class="header-text">New Projects this month</div>
      </div>
      <div class="dashboard-item current-working-project">
        <app-current-working-project [currentWorkingProjectData]="currentWorkingProjectData"></app-current-working-project>
      </div>
      <div class="dashboard-item completed-project section-with-text">
        <span class="completion-number count-number">{{ projectMetrics.projectCompletionCountMonth }}</span>
        <div class="header-text">Projects completed this month</div>
        <div class="header-text">
          <span>{{ projectMetrics.projectCompletionCountYear }}</span> Completed this year
        </div>
      </div>
    </div>
    } @if (animals) {
    <div class="animal-carousel-container" [ngClass]="{ 'centered-carousel': !projectList || projectList.length === 0 }">
      <p-carousel [value]="animals" numVisible="5" numScroll="3" [circular]="false">
        <ng-template pTemplate="item" let-animal>
          <a (click)="onLoadApplication(animal)" class="carousel-item">
            @if (animal.productType === 'SmartMap') {
            <img src="assets/images/smartmap_main.png" alt="{{ animal.productType }}" title="{{ animal.description }}" class="animal-image" />
            } @if (animal.productType === 'SmartPlanner') {
            <img src="assets/images/smartplanner.png" alt="{{ animal.productType }}" title="{{ animal.description }}" class="animal-image" />
            } @if (animal.productType === 'Frankly') {
            <img src="assets/images/frankly.png" alt="{{ animal.productType }}" title="{{ animal.description }}" class="animal-image" />
            } @if (animal.productType === 'Enterprise Tester') {
            <img src="assets/images/enterprise_tester.png" alt="{{ animal.productType }}" title="{{ animal.description }}" class="animal-image" />
            } @if (animal.productType === 'Jira') {
            <img src="assets/images/jira-logo.png" alt="{{ animal.productType }}" title="{{ animal.description }}" class="animal-image" />
            } @if (animal.productType === 'Other' && animal.icon?.hasReference) {
            <img [src]="animal.icon.attachment" alt="{{ animal.name }}" title="{{ animal.description }}" class="animal-image" />
            } @if (animal.productType === 'Other' && !animal.icon.hasReference) {
            <div class="animal-text">
              {{ animal.displayName }}
            </div>
            }
          </a>
        </ng-template>
      </p-carousel>
    </div>
    }
  </div>

  @if (isVideoPanelVisible) {
  <div class="dashboard-video-panel">
    <div class="close-button"><mat-icon (click)="hideVideoList()">close</mat-icon></div>
    <div class="dashboard-video-list">
      <app-video-list [videos]="videoList"></app-video-list>
    </div>
  </div>
  }
  <div class="div-progress">
    @if (isLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
